import React from "react";

/* change_client — cambio de cliente (solo campañas pendientes). */
export default function ClientProposal({ payload, t }) {
  return (
    <div className="chatbot-proposal-body">
      <p className="chatbot-proposal-reason">{t("ChatbotProposalClient")}</p>
      <span className="chatbot-proposal-new-value">{payload.client_name}</span>
    </div>
  );
}
